import React from "react";
import { ShieldCheck, BadgeCheck, Wallet, Users, Clock, Leaf } from "lucide-react";

const points = [
  { icon: ShieldCheck, title: "10 års garanti", text: "Vi står för vårt arbete. På takmålning lämnar vi 10 års garanti – i skrift." },
  { icon: Wallet, title: "Fast pris & ROT-avdrag", text: "Du får ett fast pris efter fri besiktning. Inga överraskningar – och vi sköter ROT-administrationen." },
  { icon: Users, title: "Egna certifierade team", text: "Aldrig underleverantörer. Samma proffs sköter hela jobbet från besiktning till färdigt tak." },
  { icon: Leaf, title: "Skonsam mjuktvätt", text: "Biologiskt nedbrytbara medel och lågtryck som tar bort mossa och alger utan att skada takpannorna." },
  { icon: Clock, title: "Snabb återkoppling", text: "Vi svarar inom en arbetsdag och bokar in besiktning där det passar dig." },
  { icon: BadgeCheck, title: "Fullt försäkrade", text: "Ansvarsförsäkring och rätt skyddsutrustning – tryggt för dig, säkert för oss." },
];

export default function Testimonials() {
  return (
    <section id="omdomen" className="bg-white py-16 lg:py-24">
      <div className="mx-auto max-w-7xl px-6">
        <div className="reveal max-w-2xl">
          <p className="text-sm font-bold uppercase tracking-[0.15em] text-[#1B45C4]">Trygghet</p>
          <h2 className="mt-3 text-3xl sm:text-4xl font-extrabold text-slate-900">Därför kan du anlita HPR med förtroende</h2>
          <p className="mt-4 text-slate-600 text-lg">
            Vi är ett nystartat takföretag med lång branscherfarenhet i teamet. Bli en av våra
            första kunder – med samma garantier och fasta priser hela vägen.
          </p>
        </div>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {points.map((p) => (
            <div key={p.title} className="reveal flex flex-col rounded-2xl bg-[#f0f7ff] p-6 ring-1 ring-[#dbeafe] transition-all hover:shadow-xl hover:shadow-[#1B45C4]/10 hover:-translate-y-1">
              <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-[#1B45C4]/10">
                <p.icon className="w-6 h-6 text-[#1B45C4]" />
              </div>
              <h3 className="mt-4 text-lg font-bold text-slate-900">{p.title}</h3>
              <p className="mt-2 text-slate-600 text-[15px]">{p.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
